import { Injectable, Injector, ErrorHandler } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

import { LoggerService } from './logger-service/logger.service';
import { StorageService } from './storage-service/storage.service';
import { DialogService } from './confirm-dialog/dialog.service';
import { ErrorNotificationService } from './error/error-notification.service';

@Injectable()
export class AppErrorHandler implements ErrorHandler {

    constructor(
        private _logger: LoggerService,
        private _storage: StorageService,
        private _dialogService: DialogService,
        private _errorNotification: ErrorNotificationService,
    ) { }

    
handleError(error: any) {
    // Find the original exception
    error = this._findOriginalError(error);

    try {
        // Log the original error and stacktrace
        this._logger.error('App Error Handler', 'Original error: ' + this._extractMessage(error));
        this._logger.error('App Error Handler', 'Original stacktrace: ' + this._findOriginalStack(error));

        // Handle expired JWT (if using JWT authentication)
        if (error instanceof HttpErrorResponse && error.status === 401) {
            this._logger.info('ApiService', 'No JWT present or expired JWT...');
            this._dialogService.alert('session-expired')
                .then(() => {
                    this._logger.info('ApiService', 'No JWT present or expired JWT => logout ');
                    this.logout();
                });
        } 
        // Handle unauthorized access
        else if (error instanceof HttpErrorResponse && error.status === 401) {
            this._logger.info('ApiService', 'Unauthorized 401...');
            this._dialogService.alert('unauthorized')
                .then(() => {
                    this._logger.info('ApiService', 'Unauthorized 401 => logout ');
                    this.logout();
                });
        } 
        // Handle other types of errors (not HTTP-related)
        else {
            this._errorNotification.generateErrorNotification(error, "", "");
        }
    } catch (e) {
        console.error('Error handling failed: ', e);
    }
}


    private _extractMessage(error): string {
        return error instanceof Error ? error.message : error.toString();
    }

    private _findOriginalError(error): any {
        let e = error.rejection ? error.rejection : error;
        while (e && e.hasOwnProperty('originalError') && e['originalError']) {
            e = e['originalError'];
        }
        return e;
    }

    private _findOriginalStack(error): string {
        let e = error;
        let stack = e instanceof Error && e.stack ? e.stack : null;
        while (e && e.hasOwnProperty('originalError') && e['originalError']) {
            e = e['originalError'];
            if (e instanceof Error && e.stack) {
                stack = e.stack;
            }
        }
        return stack;
    }

    public logout() {
        // Simply remove the token from local storage so that further request made by angula2-jwt will fail
        this._storage.removeToken();
        // It's better to reload instead of navigate to login, in order to restart the app with all data cleaned
        window.location.reload();
    }
}
